export function SendIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2634_19991)">
        <circle cx="14" cy="14" r="14" fill="currentColor" />
        <path
          d="M14 19.8334V8.16675M14 8.16675L9 13.1667M14 8.16675L19 13.1667"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2634_19991">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

SendIcon.displayName = 'SendIcon';